module.exports = __webpack_public_path__ + "media/images/ac_templates/201/redht-2a291104d0b6dc5fa6dd57f53219f701.jpg";